import { render, staticRenderFns } from "./SquareItem.vue?vue&type=template&id=781325d6&scoped=true&"
import script from "./SquareItem.vue?vue&type=script&lang=js&"
export * from "./SquareItem.vue?vue&type=script&lang=js&"
import style0 from "./SquareItem.vue?vue&type=style&index=0&id=781325d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781325d6",
  null
  
)

export default component.exports